<template>
  <i
    :class="['bi', 'bi-' + icon, 'text-' + variant]"
    v-b-tooltip="currentTOoltip"
    style="font-size: 1.5em"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'IconTooltip',
  components: {},
  props: {
    tooltip: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'question-circle-fill',
    },
    variant: {
      type: String,
      default: 'info',
    },
    tooltipPosition: {
      type: String,
      default: 'top',
    },
  },
  computed: {
    currentTOoltip() {
      return {
        disabled: !this.tooltip,
        placement: this.tooltipPosition,
        title: this.tooltip,
      };
    },
  },
});
</script>
<style scoped></style>
